module.exports = __webpack_public_path__ + "img/login_top.f196522b.svg";